import { render, staticRenderFns } from "./TasteOurCoffee.vue?vue&type=template&id=1bec8495&"
import script from "./TasteOurCoffee.vue?vue&type=script&lang=js&"
export * from "./TasteOurCoffee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports